/* global System */
// register component(s) with react habitat

export default {
  ProductTeaserboxSlider: () =>
    System.import(
      /* webpackChunkName: "ProductTeaserboxSlider" */
      './Component'
    ),
}
